import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';

const Form = React.forwardRef(({ onSubmit, useFormMethods, ...props }, ref) => {
	return (
		<FormProvider {...useFormMethods}>
			<form ref={ref} onSubmit={useFormMethods.handleSubmit(onSubmit)} {...props}>
				{props.children}
			</form>
		</FormProvider>
	);
});
Form.displayName = 'Form';

export const withDefaultUseForm = Component => {
	const FormComponent = ({ forwardedRef, criteriaMode, ...props }) => {
		const useFormMethods = useForm({
			criteriaMode: criteriaMode
		});
		return <Component ref={forwardedRef} useFormMethods={useFormMethods} {...props} />;
	};

	FormComponent.propTypes = {
		/**
		 * react ref
		 */
		forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),

		/**
		 * When set to firstError (default), only first error from each field will be gathered.
		 *
		 * When set to all, all errors from each field will be gathered.
		 */
		criteriaMode: PropTypes.oneOf(['firstError', 'all'])
	};

	FormComponent.defaultProps = {
		criteriaMode: 'all'
	};

	return React.forwardRef((props, ref) => {
		return <FormComponent forwardedRef={ref} {...props} />;
	});
};

Form.propTypes = {
	/**
	 * function to execute when the form is submitted
	 */
	onSubmit: PropTypes.func,

	/**
	 * resulting object from react-hook-form useForm api
	 */
	useFormMethods: PropTypes.object,

	children: PropTypes.any
};

export default Form;
